(() => {
    const toggle = document.getElementById('urlHelpToggle');
    const pop = document.getElementById('urlHelpPopover');
    const close = document.getElementById('urlHelpClose');

    if (!toggle || !pop) return;

    const open = () => {
        pop.classList.remove('hidden');
        toggle.setAttribute('aria-expanded', 'true');
    };

    const hide = () => {
        pop.classList.add('hidden');
        toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
        const isHidden = pop.classList.contains('hidden');
        if (isHidden) open();
        else hide();
    });

    close?.addEventListener('click', hide);

    document.addEventListener('click', (e) => {
        if (!pop.classList.contains('hidden')) {
            if (!pop.contains(e.target) && !toggle.contains(e.target)) {
                hide();
            }
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') hide();
    });
})();

(() => {
    const byId = (id) => document.getElementById(id);
    const api = "/api/seo-suite/api.php";
    let csrf = "";
    let sessionRequest = 0;
    let loggingOut = false;
    const accountMenu = byId("homepageSuiteActiveGroup");
    const accountToggle = byId("homepageSuiteAccountToggle");

    function renderSession(authenticated, email = "") {
        const login = byId("homepageSuiteLoginLink");
        if (login) login.hidden = authenticated;
        if (accountMenu) {
            accountMenu.hidden = !authenticated;
            if (!authenticated) accountMenu.open = false;
            accountMenu.closest("header").classList.toggle("is-authenticated", authenticated);
        }
        const identity = byId("homepageSuiteEmail");
        if (identity) identity.textContent = authenticated ? email : "";
        if (accountToggle) {
            accountToggle.title = authenticated ? email : "";
            accountToggle.setAttribute("aria-label", authenticated ? `Eingeloggt als ${email} – Kontomenü` : "Kontomenü öffnen");
        }
        byId("mobileSuiteLoginLink")?.classList.toggle("hidden", authenticated);
        const headerCheck = byId("homepageHeaderCheckLink");
        if (headerCheck) headerCheck.hidden = authenticated;
        const registration = byId("homepageHeaderRegisterLink");
        if (registration) registration.hidden = authenticated;
        document.querySelectorAll('[data-home-session-panel]').forEach(panel => {
            const active = (panel.dataset.homeSessionPanel === 'account') === authenticated;
            panel.classList.toggle('is-active', active);
            panel.inert = !active;
            panel.setAttribute('aria-hidden', String(!active));
        });
        const suiteLink = byId("homepageAuditSuiteLink");
        if (suiteLink) suiteLink.hidden = !authenticated;
        const auditSubmit = byId("homepageAuditSubmit");
        if (auditSubmit) {
            const label = authenticated ? "Schnelle SEO-Analyse" : "Kostenlosen SEO-Check starten";
            auditSubmit.dataset.idleLabel = label;
            if (!auditSubmit.disabled) auditSubmit.textContent = label;
        }
    }

    function updateMonitoringDomain() {
        let domain = '';
        try {
            const value = byId('homepageAuditUrl')?.value.trim() || '';
            const url = new URL(/^https?:\/\//i.test(value) ? value : 'https://' + value);
            if (['http:','https:'].includes(url.protocol) && !url.username && !url.password && url.hostname.includes('.')) domain = url.hostname;
        } catch {}
        document.querySelectorAll('[data-home-monitoring-link]').forEach(link => {
            link.href = '/premium' + (domain ? '?' + new URLSearchParams({domain}) : '') + '#seo-suite-preise';
        });
    }
    byId('homepageAuditUrl')?.addEventListener('input', updateMonitoringDomain);
    byId('homepageAuditUrl')?.addEventListener('change', updateMonitoringDomain);
    document.querySelector('[data-home-monitoring-link]')?.addEventListener('click', updateMonitoringDomain);
    updateMonitoringDomain();

    async function refreshSession() {
        if (loggingOut) return;
        const request = ++sessionRequest;
        try {
            const response = await fetch(api + "?action=session", {credentials: "same-origin", cache: "no-store"});
            if (!response.ok) return;
            const data = await response.json();
            if (request !== sessionRequest) return;
            csrf = data.csrf || "";
            renderSession(data.authenticated === true, data.email || "Ihr Suite-Konto");
        } catch {}
    }

    async function logout(event) {
        const button = event.currentTarget;
        if (loggingOut) return;
        loggingOut = true;
        sessionRequest++;
        button.disabled = true;
        try {
            const response = await fetch(api, {
                method: "POST", credentials: "same-origin",
                headers: {"Content-Type": "application/json", "X-Suite-CSRF": csrf},
                body: JSON.stringify({action: "logout"})
            });
            if (!response.ok && response.status !== 401) throw new Error("logout_failed");
            csrf = "";
            renderSession(false);
            const login = byId("homepageSuiteLoginLink");
            (login?.getClientRects().length ? login : byId("publicNavToggle"))?.focus();
        } catch {
            window.alert("Die Abmeldung konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.");
        } finally {
            button.disabled = false;
            loggingOut = false;
        }
    }

    byId("homepageSuiteLogoutBtn")?.addEventListener("click", logout);
    document.addEventListener("pointerdown", event => {
        if (accountMenu?.open && !accountMenu.contains(event.target)) accountMenu.open = false;
    });
    accountMenu?.addEventListener("focusout", event => {
        if (event.relatedTarget && !accountMenu.contains(event.relatedTarget)) accountMenu.open = false;
    });
    document.addEventListener("keydown", event => {
        if (event.key === "Escape" && accountMenu?.open) {
            event.preventDefault(); accountMenu.open = false; accountToggle?.focus();
        }
    });
    window.addEventListener("pageshow", refreshSession);
    window.addEventListener("focus", refreshSession);
    refreshSession();
})();
